// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
'use client';
import React from 'react';
import { getAnalyticsMetadataAttribute } from '@cloudscape-design/component-toolkit/internal/analytics-metadata';
import useBaseComponent from '../internal/hooks/use-base-component';
import { applyDisplayName } from '../internal/utils/apply-display-name';
import InternalToken from './internal';
import analyticsSelectors from './analytics-metadata/styles.css.js';
export default function Token({ variant = 'normal', ...props }) {
    const baseComponentProps = useBaseComponent('Token', {
        props: { variant, readOnly: props.readOnly, disabled: props.disabled },
        metadata: { hasIcon: Boolean(props.icon) },
    });
    const componentAnalyticsMetadata = {
        name: 'awsui.Token',
        label: `.${analyticsSelectors.token}`,
    };
    return (React.createElement(InternalToken, { ...props, variant: variant, ...baseComponentProps, ...getAnalyticsMetadataAttribute({ component: componentAnalyticsMetadata }) }));
}
applyDisplayName(Token, 'Token');
//# sourceMappingURL=index.js.map